import { render } from "./feature-detail.vue?vue&type=template&id=6c6edc89"
import script from "./feature-detail.vue?vue&type=script&lang=js"
export * from "./feature-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__